import { useEffect, useRef } from 'react';
import ReactBootstrapSweetAlert from 'react-bootstrap-sweetalert';

import styles from './SweetAlert.module.css';

// react-bootstrap-sweetalert 5 renders its buttons as <a href="#"> links, gives
// the title inline styles and centres the box with a flex overlay. The styles
// in app/assets/stylesheets/vendor_customization/sweetalert.scss target v4's
// markup (`button.confirm-v2`, `div.lead`, `h2`), Space no longer pressed the
// buttons, and the jQuery SweetAlert's `top/left: 50%` in
// vendor/assets/stylesheets/sweetalert.css pushed the box half off screen.
// Render v4's title, content and buttons ourselves.
const SweetAlert = ({
  children,
  title,
  customClass = '',
  style,
  onConfirm,
  onCancel,
  showConfirm = true,
  showCancel = false,
  confirmBtnText = 'OK',
  cancelBtnText = 'Cancel',
  confirmBtnBsStyle = 'primary',
  cancelBtnBsStyle = 'link',
  confirmBtnCssClass = '',
  cancelBtnCssClass = '',
  disabled = false,
  ...props
}) => {
  const confirmButton = useRef(null);

  useEffect(() => {
    confirmButton.current?.focus();
  }, []);

  return (
    <ReactBootstrapSweetAlert
      {...props}
      title=""
      customClass={`${customClass} ${styles.alert}`}
      style={{ top: 'auto', left: 'auto', right: 'auto', ...style }}
      onConfirm={onConfirm}
      onCancel={onCancel}
      customButtons={
        <>
          {showCancel && (
            <button
              type="button"
              className={`btn btn-lg btn-${cancelBtnBsStyle} ${cancelBtnCssClass}`}
              style={{ marginRight: 8 }}
              onClick={onCancel}
            >
              {cancelBtnText}
            </button>
          )}
          {showConfirm && (
            <button
              ref={confirmButton}
              type="button"
              className={`btn btn-lg btn-${confirmBtnBsStyle} ${confirmBtnCssClass}`}
              style={{ marginRight: 8 }}
              disabled={disabled}
              onClick={onConfirm}
            >
              {confirmBtnText}
            </button>
          )}
        </>
      }
    >
      {title && <h2>{title}</h2>}
      <div className="text-muted lead">{children}</div>
    </ReactBootstrapSweetAlert>
  );
};

export default SweetAlert;
